import React, { Component } from 'react';
import {
    CardBody,
    Card,
    Row, Col
} from "reactstrap"

class TYCard extends Component {

    render() {
        return (
            <Card>
                <CardBody className="card-body card-body-responsive">
                    {
                        this.props["is-loading"] ? <div className="center">
                                <i className="icon icon-loading animated spin infinite f-20 blue_dark center"> </i>
                            </div>
                            :
                            <div>
                                <div className="center-below-lg">
                                    <div className={"border-radp-50 border-2-gray blue f-"+this.props["value-size"]
                                    +" lh-"+this.props["value-size"]+" display-table-cell vertical-align-middle _w-60 _h-60 center " +
                                    "card-body-responsive-circle"}>
                                        {this.props.value}
                                    </div>
                                    <div className="ty-card-value">
                                        <div className="ty-card-value-size m-0 pink">{this.props.title}</div>
                                        <small className="text-muted">{this.props.subtitle}</small>
                                    </div>
                                </div>
                            </div>
                    }
                </CardBody>
            </Card>

        )
    }

}

TYCard.defaultProps = {
    "value-size": 14,
    value: 0,
    subtitle: "",
    title: "",
    "is-loading": false
};

export default TYCard;



// WEBPACK FOOTER //
// ./src/components/TYCard.js